import React from 'react'
import Box from '@mui/material/Box'
import MuiModal from '@mui/material/Modal'
import IconButton from '@components/IconButton/IconButton'
import { ClickAwayListener } from '@mui/material'
import { modalBackgroundStyles, modalStyles } from './Modal.styles'
import styles from './Modal.module.scss'

interface ModalProps {
  children: React.ReactNode
  onClose?: () => void
  size?: 'small' | 'medium' | 'large' | 'fit-content'
  title: string
  isOpen: boolean
  zIndex?: number
}

function Modal(props: ModalProps) {
  const { children, onClose, size = 'small', title, isOpen, zIndex } = props

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  const handleClickOutside = (event: MouseEvent | TouchEvent) => {
    const target = event.target as HTMLElement
    event.preventDefault()
    if (target.closest(`.${styles.modalWrapper}`)) {
      return
    }
    handleClose()
  }

  const getWidth = (size: 'small' | 'medium' | 'large' | 'fit-content') => {
    switch (size) {
      case 'small':
        return '400px'
      case 'medium':
        return '640px'
      case 'large':
        return '800px'
      case 'fit-content':
        return 'fit-content'
      default:
        return '600px'
    }
  }

  return (
    <MuiModal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open={isOpen}
      onClose={(_event, reason) => {
        if (reason === 'backdropClick') return
        handleClose()
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={modalBackgroundStyles}
    >
      <ClickAwayListener onClickAway={handleClickOutside}>
        <Box
          sx={{ ...modalStyles, width: getWidth(size), zIndex: zIndex || 6 }}
        >
          <div className={styles.modalWrapper}>
            <div className={styles.modalHeader}>
              <p className={`title-bold-medium ${styles.modalTitle}`}>
                {title}
              </p>
              <IconButton
                color="primary"
                icon="las la-times icon-large"
                onClick={handleClose}
              />
            </div>
            {children}
          </div>
        </Box>
      </ClickAwayListener>
    </MuiModal>
  )
}

export default Modal
